import { defineComponent as _defineComponent } from 'vue'
import ProviderIcon from '@/components/picture/ProviderIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BundleIcons',
  props: {
    packageIcons: null
  },
  setup(__props: any) {



return { __sfc: true,ProviderIcon }
}

})